import React from 'react';

import './index.less';

import {
  AgentResourceELMA365AppSettingsTypeEnum,
  AgentResourceELMA365FileSettingsTypeEnum,
  AgentResourceELMA365SessionSettingsTypeEnum,
  AgentResourceModel,
  AgentResourceTextSettingsTypeEnum,
} from '../../../../gamma-api';
import IbTypography from '../../common/IbTypography';
import IbIcon from '../../common/IbIcon';
import IbButton from '../../common/IbButton';

const MAIN_CLASS_NAME = 'message-resources';
const ITEM_CLASS_NAME = `${MAIN_CLASS_NAME}__item`;
const DELETE_ITEM_CLASS_NAME = `${ITEM_CLASS_NAME}__delete`;

const tryGetResourceLink = (resource: AgentResourceModel): string | null => {
  switch (resource.settings.type) {
    case AgentResourceTextSettingsTypeEnum.Text:
      return null;
    case AgentResourceELMA365AppSettingsTypeEnum.Elma365App:
      return resource.settings.view_url;
    case AgentResourceELMA365SessionSettingsTypeEnum.Elma365Session:
      return resource.settings.view_url;
    case AgentResourceELMA365FileSettingsTypeEnum.Elma365File:
      return resource.settings.view_url;
    default:
      return null;
  }
};

export interface IMessageResourcesProps {
  resources: AgentResourceModel[];
  onDelete?: (resource: AgentResourceModel) => void;
}

const MessageResources: React.FC<IMessageResourcesProps> = ({ resources, onDelete: onResourceDelete }) => {
  if (!resources.length) {
    return null;
  }

  return (
    <div className={MAIN_CLASS_NAME}>
      {resources.map((resource, index) => {
        const onDeleteIconClick = () => onResourceDelete?.(resource);
        const link = tryGetResourceLink(resource);
        const renderResource = () => (
          <div key={index} className={ITEM_CLASS_NAME}>
            <IbIcon iconName="ad-product" size={16} />
            <IbTypography.Paragraph ellipsis type="secondary">
              {resource.name}
            </IbTypography.Paragraph>
            {onResourceDelete && (
              <IbButton
                className={DELETE_ITEM_CLASS_NAME}
                icon={<IbIcon iconName="close" size={16} onClick={onDeleteIconClick} />}
                type="link"
              />
            )}
          </div>
        );
        return link && !onResourceDelete ? (
          <a key={index} href={link} rel="noreferrer" target="_blank">
            {renderResource()}
          </a>
        ) : (
          renderResource()
        );
      })}
    </div>
  );
};

export default MessageResources;
